import React from "react";

export default function EatInPresenceStep({ disabled, onAnswer }) {
  return (
    <section>
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-white">
          Are you currently in the restaurant?
        </h2>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row">
 
        <button
          type="button"
          onClick={() => onAnswer(true)}
          disabled={disabled}
          className="inline-flex items-center justify-center rounded-2xl border border-white/20 bg-white/10 px-6 py-3.5 font-semibold text-white transition-all duration-200 hover:border-[#fa9324] hover:bg-[#fa9324] hover:text-black active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-40"
        >
          Yes, I am
        </button>

        
        <button
          type="button"
          onClick={() => onAnswer(false)}
          disabled={disabled}
          className="inline-flex items-center justify-center rounded-2xl border border-white/10 bg-white/[0.03] px-6 py-3.5 font-semibold text-white/70 transition-all duration-200 hover:border-[#fa9324] hover:bg-[#fa9324] hover:text-black active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-40"
        >
          No, I am not
        </button>
      </div>
    </section>
  );
}